import { createContext } from 'react';

export const ContentContext = createContext({});

export const BreakpointsContext = createContext({});

export const DataContext = createContext({});
